




import { Component, Prop, Vue } from "vue-property-decorator";

import LanguageModule from "../store/modules/languageModule";
import { getModule } from "vuex-module-decorators";

const languageStore = getModule(LanguageModule);

@Component({})
export default class Citation extends Vue {
  @Prop() private language?: string;

  private beforeMount() {
    if (this.language) {
      this.setLanguage(this.language);
    }
  }

  private setLanguage(language: string) {
    languageStore.set(language);
  }
}
